import { z } from 'zod/v3';
import { errorMap, zIsoDate } from '../../common/utils';
import { zTimeHoursMinutes } from '../../common/utils/schema/zTimeHoursMinutes';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './DeadlineGenerationFormSchema.translations.json';

const { addTranslations, t } = i18nNsFactory('deadline-generation-schema');
addTranslations(translations);

export const dayType = ['CALENDAR_DAY', 'BUSINESS_DAY'] as const;

export const DeadlineGenerationFormSchema = z.object({
  dateRange: z.tuple(
    [zIsoDate(), zIsoDate()],
    errorMap(() => t('validation.dateRange.required')),
  ),
  daysAfter: z
    .number(errorMap(() => t('validation.daysAfter.required')))
    .min(1),
  dayType: z.enum(dayType),
  time: zTimeHoursMinutes(() => t('validation.time.required')),
});
